import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { PaginationModel } from "@insite/client-framework/Types/ApiModels";

export interface ApiResultModel {
    exportList: ContentModel[];
    pagination?: PaginationModel;
    errorMessage?: string;
}

export interface ApiResulNewExportModel {
    exportList: ContentModel[];
    pagination?: PaginationModel;
    errorMessage?: string;
}

export interface ContentModel {
    jobNumber: string;
    status: string;
    fileResults?: any;
}

export interface PIMParameter extends ApiParameter {
    parameter?: string;
}
const url = "/api/v2/PIMExport/ExportHistory";
const newExportUrl = "/api/v2/PIMExport/NewExport";

export async function getPIMExportApi(parameter: any) {
    const response = await get<ApiResultModel>(`${url}?page=${parameter.query.pageNo}&date=${new Date()}`);
    return response;
}

export async function getPIMNewExportApi(parameter: any) {
    const response = await get<ApiResulNewExportModel>(`${newExportUrl}?customerId=${parameter.customerId}`);
    return response;
}
